
import { map } from 'rxjs/operators';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormsModule, FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomerService } from '../../customer/customer.service';
import { CustomerStatus, Customer, State, CustomerType, CustomerTitle, PreferredContact, CustomerCFModel, Vendor } from '../../customer/customer.models';
import { SharedService } from '../.././shared/shared.service';
import { FPMessage, Severities, RoleAccess, PageKey } from '../.././shared/shared.model';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/primeng';
import { BaseComponent } from '../.././shared/base.component';
import { CapitalizeFirstPipe } from '../.././shared/pipes/custom-pipes.pipe';
import { emailValidator, compareValidator } from '../.././shared/custom-validators/custom-validator.directive';
import { CustomFieldsUpdater, CustomFieldUpdaterService } from '../.././shared/custom-fields/custom-fields-updater.service';
import { CustomFieldsConfiguration } from '../.././shared/custom-fields/custom-fields-models';
import { Type, Operator } from '../.././shared/custom-validators/custom-validator.model';
import { LoaderService } from '../.././shared/loader.service';
import { API_Settings_ERPeSales } from '../.././core/app-config';
@Component({
    selector: 'customer-edit',
    templateUrl: 'customer-edit.component.html'
})
export class CustomerEditComponent extends BaseComponent implements OnInit {

    @Input() customerId: number;
    @Input() header: string;
    @Input() rights: RoleAccess = new RoleAccess;
    @Output() dismiss = new EventEmitter();
    customer: Customer[] = [];
    customerInfo: Customer;
    customerTitle: CustomerTitle[];
    customerType: CustomerType[];
    selectedCustomerType: CustomerType[];

    custStatus: CustomerStatus[];
    selectedCustomerStatus: CustomerStatus[];
    preferredContact: PreferredContact[] = [];
    PrefContactMode: string[] = [];
    customerStatus: CustomerStatus[];
    frmCustomer: FormGroup;
    submitted: boolean = false;
    IsNetworkCustomer: boolean = false;
    message: FPMessage;
    selectItem: SelectItem[] = [];
    IsInActiveReason: boolean = false;
    headerCustomerIDCLLI: string;
    headerCustomerNameNetworkName: string;
    cLLICodeIsRequied: boolean = false;
    loader: boolean = false;
    isEdit: boolean = true;
    isAdd: boolean = true;
    selectedCustomerStatusId: number;
    @ViewChild('customerTypeDDL') customerTypeDDL: any;
    companyId: number;
    customFieldsConfiguration: CustomFieldsConfiguration;
    cfEntityId: number;
    cfPanelId: number;
    EnableCustomerMasterPassword: boolean = false;
    complexval: string[] = [];
    passwordcomplexity: string[] = [];
    isPasswordComplexityPopup: boolean = false;
    ispasswordcomplex: boolean = false;
    oldPassword: string;
    crights: RoleAccess = new RoleAccess;
    IsEnablePrefVendor: boolean = false;
    vendor: Vendor[] = [];

    //Elixir specific
    isCustomerPopupOpen: boolean = false;
    headername: string;
    IsMultipleLoginEnable:boolean = false;
    CustomerMultipleLoginEnable: number = 0;

    constructor(protected sharedService: SharedService, private loaderService: LoaderService, private updater: CustomFieldUpdaterService, private customerService: CustomerService, private router: Router, fb: FormBuilder, private formBuilder: FormBuilder, protected translateService: TranslateService) {
        super(sharedService, translateService);

        this.companyId = super.globalInfo().CompanyId;
        this.updater.update.subscribe(upd => this.updateCustomerCF(upd));

        this.frmCustomer = this.formBuilder.group({
            CustomerTypeId: ['0', Validators.required],
            CustomerName: ['', Validators.required],
            TitleId: ['0', Validators.required],
            PrefContactMode: [],//Prefered contact
            Email: ['', emailValidator],
            Password: ['', Validators.compose([compareValidator('Confpassword', Type.string, Operator.Equal, null, true)])],
            Confpassword: ['', Validators.compose([compareValidator('Password', Type.string, Operator.Equal)])],
            Phone1: [''],
            Phone2: '',
            Fax: '',
            CustomerStatusId: ['0'],
            StatusReason: '',
            ClliCode: '',
            NetworkNo: '',
            NetworkType: '',
            Node: '',
            PreferredVendorId: ['0']

            // PrefContactMode: '',
            // SpecialInstruction: [''],
            // ServiceNotes: [''],
            // CompanyName: [''],
            // TitleName: ['']
        }
            ,
            {
                validator: Validators.compose([onblurchange(), validateEmailRequired()])
            }
        );
    }



    ngOnInit() {
        debugger
        this.getChildPriviliges();

        //Elixir specific added for Multiple login enable against the customer
        this.customerService.getEnableCustomerMultipleLogin(super.globalInfo().CompanyId, this.customerId).subscribe(res => {

            this.IsMultipleLoginEnable = res == -1 ? false : true;
            this.CustomerMultipleLoginEnable = res;
        });

        // if (!this.customer) {
        //     this.customer = new Customer();
        // }
        this.customerService.GetEnablePreferredVendor(super.globalInfo().CompanyId).subscribe(res => {
            debugger
            this.sharedService.isEnablePreferredVendor = res == 1 ? true : false;
            this.sharedService.isEnablePreferredVendorEmit.emit({
                isEnablePreferVendor: this.sharedService.isEnablePreferredVendor
            });
            this.IsEnablePrefVendor = this.sharedService.isEnablePreferredVendor;
        });
        if (this.customerId != null && this.customerId != 0) {
            this.cfEntityId = 5;
            this.cfPanelId = 12;
        }
        else {
            this.cfEntityId = 1;
            this.cfPanelId = 11;
        }
        this.customerService.getCustomerTitle(super.globalInfo().CompanyId, 19).subscribe(title => {

            this.customerTitle = title;
            var ctId = this.customerTitle[0].ConfigDtlId;
            this.frmCustomer.controls['TitleId'].setValue(ctId);
        });

        this.customerService.getVendorList(super.globalInfo().CompanyId, super.globalInfo().LoginId, super.globalInfo().MaxRoleGroup, null, super.globalInfo().MaxRoleGroup == 3 ? super.globalInfo().VendorId : null).subscribe(res => {
            this.vendor = res;
        });
        this.customerService.getEnableCustomerMasterPassword(super.globalInfo().CompanyId).subscribe(res => {
            debugger
            this.EnableCustomerMasterPassword = res
            if (res == 1) {
                
                this.EnableCustomerMasterPassword = true;

            }
            else {

                this.EnableCustomerMasterPassword = false;
              
            }
        })


        this.getCustomerTypes();
        this.getPreferredContact();
        this.getCustomerStatus();
        this.onChangeCustomerType();
        this.onChangeCustomerStatus();
        //this.IsNetworkCustomer = false;
        this.headerNameChangeforNetwork();
    }
    getChildPriviliges() {
        this.loaderService.show();
        this.sharedService.getChildPrivileges(super.globalInfo().CompanyId, super.globalInfo().LoginId,
            PageKey.Customer,
            PageKey.Customer_CreateCustomer)
            .subscribe(s => {
                s.map(m => {
                    this.crights = m
                    console.log('log' + this.rights);
                })
                if (this.crights.ViewRights != 1) {
                    this.router.navigate(['/account/accessdenied']);
                }
                this.loaderService.hide();
            });
    }
    headerNameChangeforNetwork() {
        if (this.IsNetworkCustomer) {
          this.headerCustomerIDCLLI = this.translateService.instant('CLLICODE');
          this.headerCustomerNameNetworkName = this.translateService.instant('NETWORKNAME');
          this.frmCustomer.get('Phone1').setValidators([]);
          this.frmCustomer.get('Phone1').updateValueAndValidity();
        }
        else {
          this.headerCustomerIDCLLI = this.translateService.instant('CUSTOMERID');
          this.headerCustomerNameNetworkName = this.translateService.instant('CUSTOMERNAME');
          this.frmCustomer.get('Phone1').setValidators([Validators.required]);
          this.frmCustomer.get('Phone1').updateValueAndValidity();
        }
      }
    getPatchValue() {
        this.loaderService.show();

        if (this.customerId != null && this.customerId != 0) {

            this.isEdit = (this.customerId != null && this.customerId > 0 && this.rights.EditRights == 1) ? true : false;

            setTimeout(() => {
                this.customerService.getCustomer(super.globalInfo().CompanyId, this.customerId).pipe(
                    map((value) => {
                        debugger;
                        this.frmCustomer.patchValue({
                            CustomerTypeId: value.CustomerTypeId,
                            CustomerName: value.CustomerName,
                            TitleId: value.TitleId,
                            PrefContactMode: !value.PrefContactMode ? [] : value.PrefContactMode,//Prefered contact
                            Email: value.Email,
                            Phone1: value.Phone1,
                            Phone2: value.Phone2,
                            Fax: value.Fax,
                            CustomerStatusId: value.CustomerStatusId,
                            StatusReason: value.StatusReason,
                            ClliCode: value.ClliCode,
                            NetworkNo: value.NetworkNo,
                            NetworkType: value.NetworkType,
                            Node: value.Node,
                            Password: value.Password,
                            Confpassword: value.Password
                        });
                        this.oldPassword = value.Password
                    }))
                    .subscribe((value) => {
                        console.log("Error", JSON.stringify(value));
                    });

                this.customerTypeDDL.nativeElement.disabled = true;
            }, 2000);
            this.loaderService.hide();

        }
        else {
            this.loaderService.show();

            setTimeout(() => {
                if (typeof this.crights.AddRights != "undefined") {
                    this.isEdit = (this.crights.AddRights == 1) ? true : false;
                    // this.isAdd = (this.crights.AddRights == 1) ? true : false;
                }
                this.loaderService.hide();

            }, 1000);

        }

    }

    getPreferredContact() {

        this.customerService.getPreferredContact(super.globalInfo().CompanyId, 9).subscribe(res => {
            this.preferredContact = res;

            if (this.preferredContact != null || this.preferredContact != undefined) {
                for (var i = 0; i <= this.preferredContact.length - 1; i++) {
                    this.selectItem.push({ label: this.preferredContact[i].Description, value: this.preferredContact[i].ConfigDtlId });
                }
            }
            this.getPatchValue();
        });
    }
    getCustomerStatus() {
        this.customerService.getCustomerStatus(super.globalInfo().CompanyId).subscribe(res => {
            this.customerStatus = res;
            var csId = this.customerStatus[0].CustomerStatusId;

            this.frmCustomer.controls['CustomerStatusId'].setValue(csId);
        });
    }
    getCustomerTypes() {
        this.customerService.getCustomerTypes(super.globalInfo().CompanyId).subscribe(res => {
            this.customerType = res;
            var ctId = this.customerType[0].CustomerTypeId;
            this.IsNetworkCustomer = this.customerType.find(s => s.IsNetwork == 0) ? false : true;
            //this.frmCustomer.controls['CustomerTypeId'].setValue(0);
        });
    }

    // close(success?: boolean) {
    //     this.done.emit(success);
    //     if (success) {
    //         this.sharedService.notification.emit({ severity: 'success', summary: 'Customer Saved Successfully' });
    //     }
    // }


    saveCustomer(customer: Customer, formValid: boolean) {
        var npassword = customer.Password;
        this.submitted = true;
        let CustomerCFModel: CustomerCFModel;
        //customer.NewPassword = npassword;
        //customer.Password = this.oldPassword == 'undefined' ? '' : this.oldPassword;
        let customerModelEntity: Customer;
        let CustomFieldEntity = new CustomFieldsConfiguration;
        
        // CustomerCFModel.CustomerModelEntity = customerModelEntity;
        // CustomerCFModel.CustomFieldEntity = CustomFieldEntity;
        customerModelEntity = customer;
        // if (customer.CustomerTypeId == 0) return

        this.validateCLLICode(customer.ClliCode);

        if (this.IsNetworkCustomer && customer.ClliCode == "") return
        //{
        //     this.cLLICodeIsRequied = true;
        //     return;
        // }F
        if (formValid) {

            if (customer.CustomerTypeId == 0) return
            if (this.customFieldsConfiguration != undefined && this.customFieldsConfiguration.CustomFields.length > 0) {
                var formdata = this.customFieldsConfiguration.CustomFields;
                var ecount = 0;
                for (let field of formdata) {
                    if (field.IsMandatory && (field.Value == null || field.Value == "" || field.Value == "0")) {
                        this.sharedService.notification.emit({ severity: 'error', detail: 'Please Enter ' + field.FieldName + ' !' });
                        ecount++;
                    }
                }
                if (ecount > 0) return;
                CustomFieldEntity = this.customFieldsConfiguration;
            }
            CustomerCFModel = {
                CustomerModelEntity: customerModelEntity,
                CustomFieldEntity: CustomFieldEntity
            };
            this.loader = true;
            console.log("form valid");
            customer.CustomerName.trim();
            customer.CompanyId = super.globalInfo().CompanyId;
            customer.CreatedBy = super.globalInfo().LoginId;
            customer.CreatedSourceId = 1;

            customer.IsCustomerTypeHoliday = 1;
            customer.CustomerName = customer.CustomerName.trim();
            customer.Email = customer.Email.trim();
            customer.Phone1 = customer.Phone1.trim();
            customer.Phone2 = customer.Phone2.trim();
            if (this.IsNetworkCustomer) {
                customer.IsNetwork = 1;
            }
            else {
                customer.IsNetwork = 0;
            }
            customerModelEntity = customer;

            if (this.customerId) {
                customer.NewPassword = npassword;
                customer.Password = this.oldPassword == 'undefined' ? '' : this.oldPassword;
                customer.CustomerId = this.customerId;
                customer.LastChangedBy = super.globalInfo().LoginId;
                customer.UpdatedSourceId = 1;
                customerModelEntity = customer;

                CustomerCFModel = {
                    CustomerModelEntity: customerModelEntity,
                    CustomFieldEntity: CustomFieldEntity
                };
                this.customerService.updateCustomerWithCF(CustomerCFModel).subscribe(s => {
                    this.message = s.Message
                    if (s.Message.Severity == Severities.success) {
                        this.close(true);
                        // if (this.globalInfo().CompanyId == API_Settings_ERPeSales.ERP_CompanyId) {
                        //     //customer.CustomerId = customer.CustomerId;
                        //     this.customerService.pushCustomerToThirdPartySystems(customer).subscribe(s => {
                        //     });
                        // }

                    } else this.close(false);
                });
            } else {
                CustomerCFModel = {
                    CustomerModelEntity: customerModelEntity,
                    CustomFieldEntity: CustomFieldEntity
                };
                this.customerService.insertCustomerWithCF(CustomerCFModel).subscribe(s => {
                    this.message = s.Message;
                    if (s.Message.Severity == Severities.success) {

                        this.router.navigate(['/customer/customerdetails/' + s.Data]);
                        this.close(true);
                    } else this.close(false);
                });
            }
        }
    }
    updateCustomerCF(customFieldsUpdater: CustomFieldsUpdater) {
        var cf = customFieldsUpdater.value;
        if (cf.PanelId == 11 || cf.PanelId == 12)
            this.customFieldsConfiguration = cf;

    }
    close(success?: boolean) {

        this.loader = false;
        if (success || success == false) {
            if (this.message.MessageCode == "1001" || this.message.MessageCode == "1002") {
                this.sharedService.notification.emit({
                    severity: Severities[this.message.Severity],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                    detail: this.translate.instant('CUSTOMER') + " " + this.translate.instant(this.message.MessageCode)
                });
            }
            else {
                this.sharedService.notification.emit({
                    severity: Severities[this.message.Severity],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                    detail: this.translate.instant(this.message.MessageCode)
                });
                return;//added by senthilg
            }

            this.dismiss.emit(success);
        }
        else if (success == null || success == undefined)
            this.dismiss.emit(null);
    }

    onChangeCustomerType() {
        this.frmCustomer.controls['CustomerTypeId'].valueChanges.subscribe(value => {
            if (value != "0") {
                this.selectedCustomerType = this.customerType.filter(f => f.CustomerTypeId == value);
                this.IsNetworkCustomer = (this.selectedCustomerType[0].IsNetwork == 1);
            }
            this.headerNameChangeforNetwork();
        });
    }

    onChangeCustomerStatus() {
        this.frmCustomer.controls['CustomerStatusId'].valueChanges.subscribe(value => {
            // JIRA PT-763 code added by Senthilkumar G
            this.frmCustomer.controls['StatusReason'].setValue('');
            this.selectedCustomerStatus = this.customerStatus.filter(f => f.CustomerStatusId == value);
            if (this.selectedCustomerStatus.length > 0) {
                this.IsInActiveReason = (this.selectedCustomerStatus[0].CustomerStatusMasterId != 1);
            }
        })
    }

    validateCLLICode(CllICode: string) {

        if (this.IsNetworkCustomer && CllICode == '') {
            this.cLLICodeIsRequied = true;
            return;
        }
    }
    closePassComplex() {
        this.isPasswordComplexityPopup = false;
    }
    PassComplex() {
        var password = this.frmCustomer.controls["Password"].value;
        if (password) {
            this.loaderService.show();
            this.customerService.getPaswordComplexity(super.globalInfo().CompanyId, password).subscribe(passcomplex => {
                this.complexval = passcomplex;
                this.loaderService.hide();
                if (passcomplex[0] == 'True') {
                    this.ispasswordcomplex = false;
                }
                else {
                    this.ispasswordcomplex = true;
                }
            }, err => { this.loaderService.hide(); });
            onblurchange();
        }
    }
    Complexity() {
        this.passwordcomplexity = this.complexval;
        this.isPasswordComplexityPopup = true;
    }

    //Elixir specific
    openCustomerPopup(): void {
        this.headername = this.translate.instant('MULTIPLECUSTOMERLOGIN');
        this.customerId = this.customerId;
        this.isCustomerPopupOpen = true;
    }
    closeCustomerPopup(success?: boolean): void {
        if (success || success == null) {
            this.isCustomerPopupOpen = false;
            if (success) {
                // this.getCustomer();
                // this.refreshcustomfield.createCustomControls();
            }
        }
    }
}

//Page specific custom validator
function onblurchange() {
    return (formGroup: FormGroup): { [key: string]: any } => {
        let Password = formGroup.controls['Password'];
        let Email = formGroup.controls['Email'];
        let r = ((Password.value != '') && Email.value == '') ? { 'invalidEmail': true } : null;
        return r;
    };
}
function validateEmailRequired() {
    return (formGroup: FormGroup): { [key: string]: any } => {

        let Password = formGroup.controls['Password'];
        let Email = formGroup.controls['Email'];
        let r = ((Password.value != '') && Email.value == '') ? { 'emailRequired': true } : null;
        return r;
    };
}


